/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import AffiliateOverview from '@components/shared/AffiliateOverview';
import {
    Button,
    Column,
    ColumnWrap,
    CustomColumn,
    PaymentPageWrap,
    PolicyWrap,
} from '@components/shared/View';

import { useGlobalProps } from '@hooks/useGlobalProps';
import useTransCode from '@hooks/useTransCode';
import {
    STATUS_CODE,
} from '@constants/api';
import AlertModal from '@components/shared/modals/AlertModal';
import ConfirmModal from '@components/shared/modals/ConfirmModal';
import { FONT_SIZE } from '@constants/numbers';
import { getBankList, getWPolicy } from '@api/other';
import { Spin } from 'antd';
import { displayAmountWithPrecision } from '@utils/util';
import { getUserInfo } from '@api/user';
import {
    PaymentOptionOutlineButton,
    PaymentImg,
} from '@components/shared/View';
import { BANK_METAS_INFO } from '@constants/config';
import { getTTMRPaymentUrlUSDT, getTTMRPaymentUrlMPESA } from '@api/payment';

const INIT_ALERT = {
    show: false,
    title: '',
};
export default function WithdrawalTTPage() {
    const [paymentOption, setPaymentOption] = useState('');
    const [transCode, setTransCode] = useState('');
    const [bankList, setBankList] = useState([]);
    const [bankData, setBankData] = useState({});

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedPaymentOption, setSelectedPaymentOption] = useState('');
    const [errorAlert, setErrorAlert] = useState({ ...INIT_ALERT });
    const [policy, setPolicy] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const {
        user,
        userData,
        getBalance,
        pixelCodes,
    } = useGlobalProps();

    const { showTransCodeInput, needsTransCodeSetup, isTransCodeLocked, validateTransCode, tTransCode } = useTransCode();

    const { i18n, t } = useTranslation();
    const tCommon = t('common', { returnObjects: true });
    const tPayment = t('payment', { returnObjects: true });
    const tError = t('error', { returnObjects: true });

    const onPaymentOptionClick = (bankCode, bankName) => (e) => {
        // Validate trans code before opening confirm modal
        if (!validateTransCode(transCode, setErrorAlert)) {
            return;
        }
        setSelectedPaymentOption(bankName); // For display in modal
        setPaymentOption(bankCode); // For bankData lookup
        setShowConfirmModal(true);
    };



    const getPolicy = async () => {
        const res = await getWPolicy(i18n.language);
        if (res && res[0]) setPolicy(res[0]);
        else setPolicy(null);
    };




    useEffect(() => {

         if (user?.ukey) {
            getBankList(user?.ukey).then((res) => {
                if (res?.rtn === STATUS_CODE.SUCCESS && res?.bank_out_list) {
                    const bankCodes = [];
                    const bankUrls = {};
                    
                    res.bank_out_list.forEach((e) => {
                        const [bankcode, bankname, bankurl] = e;
                        bankCodes.push(bankcode.trim());
                        bankUrls[bankcode.trim()] = bankurl;
                    });
                    
                    setBankList(bankCodes);
                    setBankData(bankUrls);
                }
            });
            setPaymentOption('U');
        }        
    }, []);




    useEffect(() => {
        if (user?.ukey) getBalance();
    }, [user, getBalance]);


    useEffect(() => {
        getPolicy();
    }, [i18n.language]);

    const doWithdrawal = async () => {
        if (isLoading) return;
        setIsLoading(true);
        setShowConfirmModal(false);

        try {
            // Get the URL from bankData based on selected payment option
            const redirectUrl = bankData[paymentOption];
            
            if (redirectUrl) {
                // Redirect to the bank URL
                window.location.href = redirectUrl;
            } else {
                setErrorAlert({
                    show: true,
                    title: tCommon['common@failed'],
                    message: tError['error@server_error'],
                });
            }

            setIsLoading(false);
        } catch (error) {
            console.error('Withdrawal error:', error);
            setErrorAlert({
                show: true,
                title: tCommon['common@failed'],
                message: tError['error@server_error'],
            });
            setIsLoading(false);
        }
    };

    const handlePaymentConfirm = () => {
        setShowConfirmModal(false);
        // Get the URL from bankData based on selected payment option (using bank code)
        const redirectUrl = bankData[paymentOption];
       if (redirectUrl && user?.ukey) {
            let queryString = `&ukey=${user?.ukey}`;
            if (showTransCodeInput && transCode) {
                queryString += `&tc=${transCode}`;
            }
            window.location.href = redirectUrl + queryString;

            // Redirect to the bank URL
        } else {
            setErrorAlert({
                show: true,
                title: tCommon['common@failed'],
                message: tError['error@server_error'],
            });
        }
    };



    const displayPolicy = policy && policy.content?.length > 0;
    return (
        <PaymentPageWrap>
            {/* {contextHolder} */}
            <AffiliateOverview />
            <ColumnWrap className="mt-20 mb-1 pl-3" alignItems="start">
                <CustomColumn
                    title={tPayment['payment@withdrawal-method']}
                    child={
                        <>
                            <div style={{ display: 'flex' }}>
                                {bankList.map((code) => {
                                    const bankInfo = BANK_METAS_INFO[code];
                                    if (!bankInfo) return null;
                                    return <PaymentOptionOutlineButton
                                        key={code}
                                        onClick={onPaymentOptionClick(code, bankInfo.name)}
                                        name={bankInfo.name}
                                        isSelected={false}
                                    >
                                        <PaymentImg
                                            width={bankInfo.imageWidth ? bankInfo.imageWidth : '100px'}
                                            src={bankInfo.imageUrl}
                                            alt={bankInfo.name}
                                            name={bankInfo.name}
                                        />
                                    </PaymentOptionOutlineButton>
                                })}
                            </div>
                        </>
                    }
                />

                {/* Hidden mobile and amount fields - commented out like in DepositTTPage */}
                {/* <CustomColumn
                    title={tUser['user@phone']}
                    child={
                        <Form ref={formRef}>
                            <Form.Item
                                name={'mobile'}
                                rules={[
                                    {
                                        required: true,
                                        message: hintPhone,
                                        min: user?.minln || PHONE_DEFAULT_MIN,
                                        max: user?.maxln || PHONE_DEFAULT_MAX,
                                        whitespace: false,
                                        validator: validatorPhone,
                                    },
                                ]}
                                // help={hintPhone}
                                initialValue={mobile}
                                className={`register-form-mobile`}
                            >
                                <Input
                                    name={'mobile'}
                                    type={
                                        'text'
                                    }
                                    addonBefore={<FaMobile />}
                                    maxLength={
                                        ''
                                    }
                                    value={mobile}
                                    onChange={handleInputChange}
                                    readOnly={true}
                                />
                            </Form.Item>
                        </Form>
                    }
                /> */}

                {/* <AmountColumn
                    title={tPayment['payment@withdrawal-amount']}
                    mainUnit={mainUnit}
                    displayAmountOptions={withdrawAmountOptions && withdrawAmountOptions.display}
                    amount={amount}
                    onAmountChange={handleInputChange}
                    onSelecteAmount={handleSelectAmount}
                    amountInfos={amountInfos}
                    displayStepper={withdrawStepperOptions && withdrawStepperOptions.display}
                /> */}

                {showTransCodeInput && (
                    <Column
                        title={tTransCode['transCode@enterToVerify']}
                        name={'transCode'}
                        value={transCode}
                        onChange={(e) => setTransCode(e.target.value)}
                    />
                )}
                {isTransCodeLocked && (
                    <TransCodeMessage className="locked">
                        {tTransCode['transCode@locked']}
                    </TransCodeMessage>
                )}
                {needsTransCodeSetup && (
                    <TransCodeMessage className="warning">
                        {tTransCode['transCode@pleaseSet']}
                    </TransCodeMessage>
                )}

                <CustomColumn
                    notRequired
                    child={
                        <WithdrawalFeeInfo>
                            <p>
                                {userData?.bo_min_pts > 0 && !user?.ko_max && `${tPayment['payment@withdrawal-min-amount']}: ${displayAmountWithPrecision(
                                    userData?.bo_min_pts
                                )} Cr.`}
                                {!userData?.bo_min_pts && user?.ko_max > 0 && `${tPayment['payment@withdrawal-max-amount']}: ${displayAmountWithPrecision(
                                    user?.ko_max
                                )} Cr.`}
                                {userData?.bo_min_pts > 0 && user?.ko_max > 0 && `${tPayment['payment@withdrawal-amount-limit']
                                    }: ${displayAmountWithPrecision(
                                        userData?.bo_min_pts
                                    )} ~ ${displayAmountWithPrecision(
                                        user?.ko_max
                                    )} Cr.`}
                            </p>
                        </WithdrawalFeeInfo>
                    }
                />

                {/* Submit button hidden - payment selection now triggers direct confirmation */}
                <div style={{display: 'none'}}>
                    <CustomColumn
                        child={
                            <SpinContainer>
                                {isLoading ? (
                                    <Spin
                                        style={{
                                            top: '25%',
                                            left: '25%',
                                            position: 'absolute',
                                        }}
                                    />
                                ) : (
                                    <Button
                                        onClick={() => {
                                            if (!paymentOption) {
                                                setErrorAlert({
                                                    show: true,
                                                    title: tCommon['common@failed'],
                                                    message: tError['error@deposit_option_required'],
                                                });
                                                return;
                                            }

                                            if (pixelCodes && pixelCodes.length > 0) {
                                                pixelCodes.forEach((code) => window.fbq('trackSingleCustom', code, 'WithdrawlSubmission'));
                                            }

                                            setShowConfirmModal(true);
                                        }}
                                    >
                                        {tCommon['common@submit']}
                                    </Button>
                                )}
                            </SpinContainer>
                        }
                        notRequired
                    />
                </div>
            </ColumnWrap>
            {displayPolicy && (
                <PolicyWrap>
                    <div dangerouslySetInnerHTML={{ __html: policy.content }} />
                </PolicyWrap>
            )}
            <ConfirmModal
                show={showConfirmModal}
                title={tPayment['payment@going-to-withdrawal-screen']?.replace('{provider}', selectedPaymentOption)}
                message={tPayment['payment@confirm-go-withdrawal']?.replace('{provider}', selectedPaymentOption)}
                actionTitle={tPayment['payment@go']}
                onConfirm={handlePaymentConfirm}
                onCancel={() => setShowConfirmModal(false)}
            />
            <AlertModal
                {...errorAlert}
                onConfirm={() => setErrorAlert({ ...INIT_ALERT })}
            />
        </PaymentPageWrap>
    );
}

// const MobileInfo = styled.div`

//     display: flex;
//     align-items: center;
//     > span {
//         color: black;   
//         margin-right: 8px;
//         font-size: ${FONT_SIZE.NORMAL};
//         font-weight: 800;
//     }
// `;

const WithdrawalFeeInfo = styled.div`
    color: black;
    > p {
        margin: 0;
        margin-top: 5px;
        font-size: ${FONT_SIZE.ALERT_MODAL_TITLE};
        font-weight: 800;
    }
    .text-center {
        text-align: center;
    }
`;

const SpinContainer = styled.div`
    text-align: center;
    position: relative;
    width: 100px;
    height: 40px;
`;

const TransCodeMessage = styled.div`
    padding: 10px;
    border-radius: 4px;
    margin-top: 10px;
    &.locked {
        color: #d9534f;
        background: #fdf2f2;
    }
    &.warning {
        color: #856404;
        background: #fff3cd;
    }
`;
